import { call, put } from "redux-saga/effects";
import { create, deleteRec, downloadTemp, extractData, find, loadStatistics, search, update, uploadData, uploadDocument } from "./vehiculeService";
import { createModule } from "saga-slice";

const vehiculeSlice = createModule({
    name: "vehicule",
    initialState: {
        vehicules: [],
        isFetching: false,
        error: null,
        total: 0
    },
    reducers: {
        downloadTemp: (state) => {
            state.isFetching = true;
        },
        find: (state) => {
            state.isFetching = true;
        },
        create: (state) => {
            state.isFetching = true;
        },
        update: (state) => {
            state.isFetching = true;
        },
        search: (state) => {
            state.isFetching = true;
        },
        loadStatistics: (state) => {
            state.isFetching = true;
        },
        uploadData: (state) => {
            state.isFetching = true;
        },
        extractData: (state) => {
            state.isFetching = true;
        },
        delete: (state) => {
            state.isFetching = true;
        },
        uploadDocument: (state) => {
            state.isFetching = true;
        },
        fetchSuccess: (state, payload) => {
            const body = payload?.body || {};
            state.vehicules = body.content || [];
            state.total = body.totalElements ?? state.vehicules.length;
        },
        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state) => {
            state.isFetching = false;
            state.error = "An error occured";
        },
    },
    sagas: (A) => ({
        *[A.downloadTemp]({ payload }) {
            try {
                const { data } = yield downloadTemp(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.uploadData]({ payload }) {
            try {
                yield uploadData(payload.formData);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.extractData]({ payload }) {
            try {
                const { data } = yield extractData(payload.formData);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.uploadDocument]({ payload }) {
            try {
                const { data } = yield uploadDocument(payload.formData);
                yield put(A.finishFetching());
                if (payload.onSuccess) yield call(payload.onSuccess, data);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                if (payload.onError) yield call(payload.onError, e);
                yield put(A.fetchError());
            }
        },
        *[A.delete]({ payload }) {
            try {
                yield deleteRec(payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.create]({ payload }) {
            try {
                const {data} = yield create(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                if (payload.onError) yield call(payload.onError, e);
                yield put(A.fetchError());
            }
        },

        *[A.update]({ payload }) {
            try {
                const {data} = yield update(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                if (payload.onError) yield call(payload.onError, e);
                yield put(A.fetchError());
            }
        },
        *[A.find]({ payload }) {
            try {
                const { data } = yield find(payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.loadStatistics]({ payload }) {
            try {
                const { data } = yield loadStatistics();
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.search]({ payload }) {
            try {
                const { data } = yield search(payload);
                yield put(A.finishFetching());
                yield put(A.fetchSuccess(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
    })
})

export default vehiculeSlice;
export const vehiculeActions = vehiculeSlice.actions;
